<script setup lang="ts">
import { onBeforeUnmount, onMounted, reactive, Ref, ref, watch } from 'vue';
import i18n from '@/localization/i18n';

import BusinessRequestProgressBar from "./BusinessRequestProgressBar.vue";
import AddressSearch from '@/views/components/AddressSearch.vue';
import { storeToRefs } from 'pinia';
import { useBusinessRequestFormStore } from '@/pages/index/stores/business-request-form-store';
import { logNewEvent } from '@/services/modules/firebase';

const businessRequestFormStore = useBusinessRequestFormStore()
const { addressFormData} = storeToRefs(businessRequestFormStore)

const t = i18n.global.t

const formData = reactive({
   town:  "",
   zipcode:  null
})

const zipcode: Ref<string|null> = ref(null)

onMounted(() => {
    if(addressFormData.value!.addressItem){
        let town = addressFormData.value!.addressItem!.city?? ''
        zipcode.value = addressFormData.value!.addressItem!.postcode ?? null
        if(town !== ''){
            town += " " + (zipcode.value ? ' ('+zipcode.value+')':  "")
        }
        formData.town = town
    }
})

const validateForm = () =>{
    let isAddressValid: boolean = addressFormData.value!.addressItem! !== null
    if(formData.town !== "" && !isAddressValid){
        formErrors.address = t("Sélection à réaliser dans la liste")
        return
    }
    
    formErrors.address = !isAddressValid ? t("w_msg_frmVal_required") : ""

    if(isAddressValid){
        logNewEvent("presta_request_submit_city")
        businessRequestFormStore.next_step('description')
    }
}

const back = () =>{
    businessRequestFormStore.prev_step('urgency')
}

const formErrors = reactive({
   address: ""
})

const unwatchFormdata = watch(formData, (newVal) => {
    if(newVal.town === ""){
        addressFormData.value.addressItem = null
        zipcode.value = null
    }
    formErrors.address = ""
})

onBeforeUnmount(() => {
    unwatchFormdata()
})
</script>

<template>
    <div class="rounded main fullHeight" style="height: 550px">
        <BusinessRequestProgressBar />
        <div class="fullRemainingHeight">
            <div class="expanded">
                <div class="h-style h3-style use-poppins text-center mt-4">
                    {{ t("w_txt_business_request_where") }}
                </div>
                <div class="mt-3 mx-md-5">
                    <p class="p-style">
                        {{ t("w_txt_business_request_address_instruction") }}
                    </p>
                </div>
                <div class="validate-form px-2 mx-md-2 mt-5">
                    <form @submit.prevent class="col-12 col-sm-12 mb-2 border-end-light">
                        <AddressSearch
                            v-model:town="formData.town"
                            v-model:zipcode="zipcode"
                            v-model:address-item="addressFormData.addressItem"
                            :show-zipcode="true"
                            :use-municipality="true"
                            @update:town="newValue => formData.town = newValue"
                            :show-label="false"
                            :max-length="'38'"
                            :placeholder="t('w_txt_business_request_address_placeholder')"
                        />
                        <p class="mb-0 text-danger" v-if="formErrors.address && addressFormData!.addressItem! === null">{{ formErrors.address }}</p>
                    </form>
                </div>
            </div>
            <div style="margin-top: auto; margin-bottom:15px ">
                <button @click="back"  type="button" class="btn btn-outline-secondary on-action-btn me-3 mt-2 mb-2 custom-btn-width">
                    {{ t("w_act_business_request_previous") }}
                </button>

                <button @click="validateForm"  
                    type="button" class="btn btn-primary mt-2 mb-2 on-action-btn custom-btn-width"
                    :disabled="addressFormData!.addressItem! === null"
                    :class="{ 'invalid-btn-style': addressFormData!.addressItem! === null}"
                    >
                    {{ t("w_act_business_request_next") }}
                </button>
            </div>
        </div>

    </div>
</template>

<style scoped>
.btn-primary:focus{
    background-color: #FEB23C !important;
}
.main {
    padding-top: 15px;
    position: relative;
}

.bg {
    background-color: #FEB23C !important;
}

.fullHeight {
    height: 100%;
    z-index: 1px;
    border: none !important;
    display: flex;                  
    flex-direction: column;
}

.fullRemainingHeight {
    display: flex;                  
    flex-direction: column; 
    height: 100%;  
}

.expanded{
    flex-grow: 1;
    margin-left: 10px;
    margin-right: 10px;
}

.custom-btn-width {
    min-width: 130px;
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {
    /* Styles for medium screens */
    .expanded{
        margin-left: 50px !important;
        margin-right: 50px !important;
    }

    .custom-btn-width {
        min-width: 150px !important;
    }
}
</style>